import {
  realEstateQuotes,
  realEstateTransactions,
  objectsOfValueQuotes,
  objectsOfValueTransactions,
  metalsQuotes,
  metalsTransactions,
  unlistedSharesQuotes,
  unlistedSharesTransactions,
  stocksQuotes,
  stocksTransactions,
  stocksTransactionsReport,
  depositsTransactions,
  loansTransactions,
  pensionQuotes,
  pensionTransactions,
} from './layouts/index';

const emptyLayout = {
  columnParams: 'grid-cols-[1fr]',
  columns: [],
};

export default function getTableLayout(category, displayedData) {
  if (!category || !displayedData) return emptyLayout;

  // handle cashflow mode -- if displayedData === 'cashflow', always return depositsTransactions;
  if (displayedData === 'cashflow') {
    return depositsTransactions;
  }

  if (displayedData === 'quotes') {
    switch (category) {
      case 'realEstate':
        return realEstateQuotes;
      case 'stocks':
      case 'crypto':
        return stocksQuotes;
      case 'pension':
        return pensionQuotes;
      case 'objectsOfValue':
        return objectsOfValueQuotes;
      case 'metals':
        return metalsQuotes;
      case 'unlistedShares':
        return unlistedSharesQuotes;
      default:
        return emptyLayout;
    }
  }

  if (displayedData === 'holdings') {
    switch (category) {
      case 'realEstate':
        return realEstateTransactions;
      case 'stocks':
      case 'crypto':
        return stocksTransactions;
      case 'stocksPositionsReport':
        return stocksTransactionsReport;
      case 'deposits':
        return depositsTransactions;
      case 'loans':
        return loansTransactions;
      case 'pension':
        return pensionTransactions;
      case 'objectsOfValue':
        return objectsOfValueTransactions;
      case 'metals':
        return metalsTransactions;
      case 'unlistedShares':
        return unlistedSharesTransactions;
      default:
        return emptyLayout;
    }
  }

  return emptyLayout;
}
